<template>
    <van-nav-bar class="navClass" title="Apertura de Cuenta" fixed left-arrow @click-left="onClickLeft" placeholder />
    <navbar v-if="isPc" />
    <div class="page">
        <div class="zhuce">
            <van-form @failed="onFailed" @submit="onSubmit">
                <div class="title" style="margin-top: 0">Número de teléfono</div>

                <van-field v-model="username" name="username" type="number"
                    placeholder="Por favor ingrese su número de teléfono" :rules="[
                        { required: true, message: 'Ingrese su número telefónico' },
                        { pattern: /^\d{5,14}$/, message: 'Formato incorrecto' }
                    ]">
                    <template #label>
                        <!-- PC：自定义下拉 -->
                        <div v-if="isPc" class="area-dropdown" ref="dropdownRef">
                            <div class="area-trigger" @click="toggleDropdown">
                                <span>+{{ areaCode }}</span>
                                <i class="arrow" :class="{ open: dropdownOpen }"></i>
                            </div>

                            <ul v-show="dropdownOpen" class="area-menu">
                                <li v-for="item in columns" :key="item.value"
                                    :class="{ active: areaCode === item.value }" @click="selectArea(item.value)">
                                    +{{ item.text }}
                                </li>
                            </ul>
                        </div>

                        <!-- Mobile：Picker -->
                        <div v-else class="area-picker" @click="openPicker">
                            +{{ areaCode }}
                            <van-icon name="arrow-down" />
                        </div>
                    </template>
                </van-field>

                <div class="title">Contraseña</div>
                <van-field v-model="password" name="password" :type="isShowPassword ? 'text' : 'password'"
                    placeholder="Por favor ingrese su contraseña" :rules="[
                        { required: true, message: 'Ingrese una contraseña' },
                        {
                            pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/,
                            message: 'Mínimo 6 caracteres con combinación de letras y números'
                        }
                    ]">
                    <template #right-icon>
                        <van-icon :name="isShowPassword ? 'eye-o' : 'closed-eye'"
                            @click="isShowPassword = !isShowPassword" />
                    </template>
                </van-field>

                <div class="title">Confirmar Contraseña</div>
                <van-field v-model="confirmPassword" name="confirmPassword"
                    :type="isShowConfirmPassword ? 'text' : 'password'"
                    placeholder="Por favor ingrese la contraseña nuevamente" :rules="[
                        { required: true, message: 'Confirme la contraseña' },
                        {
                            pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/,
                            message: 'Formato incorrecto'
                        },
                        { validator: validateConfirm, message: 'Las contraseñas no coinciden' }
                    ]">
                    <template #right-icon>
                        <van-icon :name="isShowConfirmPassword ? 'eye-o' : 'closed-eye'"
                            @click="isShowConfirmPassword = !isShowConfirmPassword" />
                    </template>
                </van-field>

                <div class="title">Código de invitación (obligatorio)</div>
                <van-field v-model="invite" name="invite" placeholder="Código de invitación (obligatorio)"
                    :rules="[{ required: true, message: 'Ingrese el código de invitación' }]" />

                <div class="btn-box">
                    <van-button class="btn" :loading="loading" loading-text="Apertura de cuenta en proceso..."
                        native-type="submit">
                        Apertura de cuenta
                    </van-button>
                </div>
            </van-form>
        </div>
    </div>

    <!-- Mobile Picker -->
    <van-popup v-model:show="showPicker" round position="bottom">
        <van-picker :columns="columns" :model-value="[areaCode]" confirm-button-text="Confirmar"
            cancel-button-text="Cancelar" @confirm="onConfirm" @cancel="showPicker = false" />
    </van-popup>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { showSuccessToast } from 'vant'
import { useRoute, useRouter } from 'vue-router'
import { register } from '@/api'

const onClickLeft = () => history.back()
const route = useRoute()
const router = useRouter()

const username = ref('')
const password = ref('')
const confirmPassword = ref('')
const invite = ref(route.query.invite || '')
const areaCode = ref('54')

const isShowPassword = ref(false)
const isShowConfirmPassword = ref(false)
const loading = ref(false)

const isPc = ref(false)
const checkPc = () => (isPc.value = window.innerWidth > 600)

onMounted(() => {
    checkPc()
    window.addEventListener('resize', checkPc)
    document.addEventListener('click', handleClickOutside)
})

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside)
})

const columns = [
    { text: '54', value: '54' },
    { text: '1', value: '1' }
]

// 自定义下拉逻辑
const dropdownOpen = ref(false)
const dropdownRef = ref(null)

const toggleDropdown = () => {
    dropdownOpen.value = !dropdownOpen.value
}

const selectArea = (value) => {
    areaCode.value = value
    dropdownOpen.value = false
}

const handleClickOutside = (e) => {
    if (dropdownRef.value && !dropdownRef.value.contains(e.target)) {
        dropdownOpen.value = false
    }
}

// Mobile Picker
const showPicker = ref(false)
const openPicker = () => (showPicker.value = true)

const onConfirm = ({ selectedOptions }) => {
    areaCode.value = selectedOptions[0].value
    showPicker.value = false
}

const validateConfirm = () => confirmPassword.value === password.value

const onSubmit = (values) => {
    loading.value = true
    register({
        ...values,
        username: areaCode.value + values.username,
        confirmPassword: undefined
    })
        .then((res) => {
            if (res.code === 200) {
                showSuccessToast(res.message)
                router.push('/success')
            }
        })
        .finally(() => (loading.value = false))
}

const onFailed = (err) => console.log(err)
</script>

<style scoped lang="scss">
/* 解决 van-field 下拉被裁剪的问题 */
:deep(.van-cell) {
    overflow: visible;
}

/* 如果 label 区域仍被裁剪，再加这个 */
:deep(.van-field__label) {
    overflow: visible;
}

.page {

    padding: 15px;
    background: #fdfdfe;
    min-height: calc(100vh - 46px);
}

.zhuce {
    max-width: 560px;
    margin: auto;
    background: #fff;
    padding: 30px;
    border-radius: 20px;
    box-shadow: 0 6px 10px rgba(0, 34, 158, 0.05);

    .title {
        margin: 25px 0 10px;
        font-size: 15px;
        font-weight: bold;
    }

    .van-cell {
        background: #f5f8fa;
        border-radius: 8px;
        margin-bottom: 15px;
    }

    .btn {
        width: 100%;
        background: #1e27f3;
        color: #fff;
        margin-top: 30px;
        transition: all 0.3s;

        &:hover {
            background-color: #0e0e0e;
        }
    }
}

/* ===== PC 自定义下拉 ===== */
.area-dropdown {
    position: relative;
    min-width: 60px;
}

.area-trigger {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    font-weight: 600;
}

.arrow {
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 6px solid #666;
    transition: 0.2s;
}

.arrow.open {
    transform: rotate(180deg);
}

.area-menu {
    position: absolute;
    top: 36px;
    left: -20px;
    z-index: 20;
    width: 120px;
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    overflow: hidden;
}

.area-menu li {
    padding: 8px 16px;
    font-size: 16px;
    cursor: pointer;
}

.area-menu li:hover,
.area-menu li.active {
    background: #eef0ff;
    color: #1e27f3;
}

/* Mobile */
.area-picker {
    display: flex;
    align-items: center;
    gap: 6px;
}

/* PC 隐藏 nav */
@media screen and (min-width: 601px) {
    .navClass {
        display: none;
    }

    .page {
        padding: 50px 15px 15px;
        background: #fdfdfe;
        min-height: auto;
    }

    .area-select:hover {
        background-color: rgba(30, 39, 243, 0.06);
        border-radius: 4px;
    }

    :deep(.van-cell:focus-within) {
        box-shadow: 0 0 0 2px rgba(30, 39, 243, 0.15);
    }
}
</style>